import { useQuery } from 'react-query';

import { getUnreadCounter } from 'api/endPoints/getUnreadCounter';

export const useQueryUnreadNotificationsCounter = () => {
    return useQuery<number, QueryError>('UnreadNotificationsCounter', getUnreadCounter);
};
